import BaseComponent from "../BaseComponent";
import PropTypes from "prop-types";
import {Paper} from "@mui/material";
import shortid from "shortid";

class Window extends BaseComponent {

  render() {
    let {title, id = shortid(), children, className = ''} = this.props;
    let classes = 'CNINFO-window rounded-lg p-3 ' + className;
    title = title ? <h2>{title}</h2> : <></>;
    return <Paper className={classes} id={id}>
      {title}
      {children}
    </Paper>;
  }
}

Window.propTypes = {
  id: PropTypes.string,
  title: PropTypes.string,
  className: PropTypes.string,
  onCloseButtonClick: PropTypes.func,
}

export default Window;
